import gsap from "gsap";
import PubSub from 'underpub-js';

var ExpertiseListingWithChildren = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

ExpertiseListingWithChildren.prototype.init = function () {

	let self = this;
	this.$listingItems = this.options.$el.find("[data-expertise-listing-item]");
	this.$childrenColumn = this.options.$el.find(".children-column");
	this.$childContainers = this.options.$el.find(".flex-row-container");
	this.$contentRow = this.options.$el.find(".content-row");
	this.$grandchildrenTriggers = this.options.$el.find(`.child-service.has-grandchildren .Icon`);

	this.openChildService = null;

	this.setChildrenColumnHeight();
	PubSub.subscribe('resized', function() {
		self.setChildrenColumnHeight();
	});

	if(window.Breakpoint.value === "xsmall" || window.Breakpoint.value === "small"){
		return;
	}

	this.$listingItems.on("mouseenter", function(){

		let $el = $(this);

		if($el.hasClass("is-active")){
			return;
		}

		let slug = $el.data("slug");
		let $childContainer = self.$childContainers.filter(`[data-parent-slug='${slug}']`);
		let timeline = gsap.timeline();

		timeline.to(self.$childContainers, {
			opacity: 0,
			duration: .25
		});
		timeline.set(self.$childContainers, {display: "none"});
		timeline.set($childContainer, {display: "block", opacity: 0, position: "sticky"});
		timeline.to($childContainer, {opacity: 1, duration: .25});

		self.$listingItems.removeClass("is-active");
		$el.addClass("is-active");

		self.$childContainers.removeClass("is-active");
		$childContainer.addClass("is-active");

	});

	this.$grandchildrenTriggers.on('click', function() {

		let $el = $(this);
		let $childServiceWrapper = $el.closest(`.child-service-wrapper`);

		if ($childServiceWrapper.is(self.openChildService)) {
			console.log('close dropdown');
			self.closeDropdown($childServiceWrapper);
		}
		else {
			console.log('open dropdown');
			self.openDropdown($childServiceWrapper);
		}

	});

};

/**
 * Looping over all our child containers to get the tallest contianer
 * @returns {number}
 */
ExpertiseListingWithChildren.prototype.setChildrenColumnHeight = function(){

	let self = this;

	if(window.Breakpoint.value === "xsmall" || window.Breakpoint.value === "small")
	{
		this.$childrenColumn.css('min-height', 0);
	}
	else
	{
		// set children column height
		let maxChildHeight = this.getMaxChildHeight();
		this.$contentRow.css('min-height', maxChildHeight);
	}

};

/**
 * Looping over all our child containers to get the tallest contianer
 * @returns {number}
 */
ExpertiseListingWithChildren.prototype.getMaxChildHeight = function(){

	let initialHeight = 0;

	this.$childContainers.each(function(index){

		let $el = $(this);

		// Making sure we can actually read the height
		if(! $el.hasClass("is-active")){
			gsap.set(this, {display: "block", opacity: 0, position:"absolute"});
		}

		// Adjusting our max height
		let newHeight = $el.outerHeight() + 80;
		if(newHeight > initialHeight){
			initialHeight = newHeight;
		}

		// Setting the in-active states back to the right styles
		if(! $el.hasClass("is-active")){
			gsap.set(this, {display: "none", opacity: 1, position:"sticky"});
		}

	});

	return initialHeight;

};

ExpertiseListingWithChildren.prototype.openDropdown = function($childServiceWrapper) {

	var self = this;

	let $grandchildrenWrapper = $childServiceWrapper.find(`.grandchildren-wrapper`);
	let $rowArrow = $childServiceWrapper.find(`.Icon`);

	self.closeDropdown(this.openChildService); // close the open row, max 1 open at a time

	this.openChildService = $childServiceWrapper;
	$childServiceWrapper.find(`.child-service`).addClass(`active`);

	gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
				duration: 0.45
			}
		}
	)
	.to($grandchildrenWrapper,
		{
			height: "auto"
		}
	)
	.to($rowArrow,
		{
			rotate: 90
		},
		"<"
	)
	;

};

ExpertiseListingWithChildren.prototype.closeDropdown = function($childServiceWrapper) {

	var self = this;

	if (!$childServiceWrapper) { return; }

	let $grandchildrenWrapper = $childServiceWrapper.find(`.grandchildren-wrapper`);
	let $rowArrow = $childServiceWrapper.find(`.Icon`);

	self.openChildService = null;
	$childServiceWrapper.find(`.child-service`).removeClass(`active`);

	gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
				duration: 0.45
			}
		}
	)
	.to($grandchildrenWrapper,
		{
			height: 0
		}
	)
	.to($rowArrow,
		{
			rotate: 0
		},
		"<"
	)
	;

};

export default ExpertiseListingWithChildren;
